import { GridApiPro } from '@mui/x-data-grid-pro';
import React, {
  createContext,
  FC,
  MutableRefObject,
  PropsWithChildren,
  ReactNode,
  useContext,
  useState,
} from 'react';

type GridApiContextValue = MutableRefObject<GridApiPro> | null;

const GridApiContext = createContext<GridApiContextValue>(null);

interface GridApiProviderProps extends PropsWithChildren {
  apiRef: MutableRefObject<GridApiPro> | null;
}

export const GridApiProvider: FC<GridApiProviderProps> = ({ apiRef, children }) => {
  return <GridApiContext.Provider value={apiRef}>{children}</GridApiContext.Provider>;
};

export const useGridApi = (): MutableRefObject<GridApiPro> | null => {
  const context = useContext(GridApiContext);

  return context ?? null;
};

export const useGridApiProvider = () => {
  const [apiRef, setApiRef] = useState<MutableRefObject<GridApiPro> | null>(null);

  return {
    apiRef,
    onApiRefReady: setApiRef,
    renderWithProvider: (children: ReactNode) =>
      apiRef ? <GridApiProvider apiRef={apiRef}>{children}</GridApiProvider> : null,
  };
};
